import microActive from "../../assets/icons/micro_active.svg";
import microHover from "../../assets/icons/micro_hover.svg";
import microDisabled from "../../assets/icons/micro_disabled.svg";
import microDisabledHover from "../../assets/icons/micro_disabled_hover.svg";
import uploadActive from "../../assets/icons/upload_active.svg";
import uploadHover from "../../assets/icons/upload_hover.svg";
import uploadDisabled from "../../assets/icons/upload_disabled.svg";
import uploadDisabledHover from "../../assets/icons/upload_disabled_hover.svg";
import sendActive from "../../assets/icons/send_active.svg";
import sendHover from "../../assets/icons/send_hover.svg";
import sendDisabled from "../../assets/icons/send_disabled.svg";
import sendDisabledHover from "../../assets/icons/send_disabled_hover.svg";
import stopActive from "../../assets/icons/stop_active.svg";
import stopHover from "../../assets/icons/stop_hover.svg";
import stopDisabled from "../../assets/icons/stop_disabled.svg";
import stopDisabledHover from "../../assets/icons/stop_disabled_hover.svg";
import pptActive from "../../assets/icons/downloadPPT_active.svg";
import pptHover from "../../assets/icons/downloadPPT_hover.svg";
import pptDisabled from "../../assets/icons/downloadPPT_disabled.svg";
import pptDisabledHover from "../../assets/icons/downloadPPT_disabled_hover.svg";
import wordActive from "../../assets/icons/downloadWord_active.svg";
import wordHover from "../../assets/icons/downloadWord_hover.svg";
import wordDisabled from "../../assets/icons/downloadWord_disabled.svg";
import wordDisabledHover from "../../assets/icons/downloadWord_disabled_hover.svg";
import newChatActive from "../../assets/icons/newChat_active.svg";
import newChatHover from "../../assets/icons/newChat_hover.svg";
import newChatDisabled from "../../assets/icons/newChat_disabled.svg";
import newChatDisabledHover from "../../assets/icons/newChat_disabled_hover.svg";
import infoActive from "../../assets/icons/info_active.svg";
import infoHover from "../../assets/icons/info_hover.svg";
import infoDisabled from "../../assets/icons/info_disabled.svg";
import infoDisabledHover from "../../assets/icons/info_disabled_hover.svg";
import chatHistoryActive from "../../assets/icons/chatHistory_active.svg";
import chatHistoryHover from "../../assets/icons/chatHistory_hover.svg";
import chatHistoryDisabled from "../../assets/icons/chatHistory_disabled.svg";
import chatHistoryDisabledHover from "../../assets/icons/chatHistory_disabled_hover.svg";
import deleteActive from "../../assets/icons/delete_active.svg";
import deleteHover from "../../assets/icons/delete_hover.svg";
import deleteDisabled from "../../assets/icons/delete_disabled.svg";
import deleteDisabledHover from "../../assets/icons/delete_disabled_hover.svg";
import editActive from "../../assets/icons/edit_active.svg";
import editHover from "../../assets/icons/edit_hover.svg";
import editDisabled from "../../assets/icons/edit_disabled.svg";
import editDisabledHover from "../../assets/icons/edit_disabled_hover.svg";
import searchActive from "../../assets/icons/search_active.svg";
import searchHover from "../../assets/icons/search_hover.svg";
import searchDisabled from "../../assets/icons/search_disabled.svg";
import searchDisabledHover from "../../assets/icons/search_disabled_hover.svg";
import downloadActive from "../../assets/icons/download_active.svg";
import downloadHover from "../../assets/icons/download_hover.svg";
import downloadDisabled from "../../assets/icons/download_disabled.svg";
import downloadDisabledHover from "../../assets/icons/download_disabled_hover.svg";
import closeActive from "../../assets/icons/close_active.svg";
import closeHover from "../../assets/icons/close_hover.svg";
import closeDisabled from "../../assets/icons/close_disabled.svg";
import closeDisabledHover from "../../assets/icons/close_disabled_hover.svg";
import libraryActive from "../../assets/icons/library_active.svg";
import libraryHover from "../../assets/icons/library_hover.svg";
import libraryDisabled from "../../assets/icons/library_disabled.svg";
import libraryDisabledHover from "../../assets/icons/library_disabled_hover.svg";
import clearActive from "../../assets/icons/delete1_active.svg";
import clearHover from "../../assets/icons/delete1_hover.svg";
import clearDisabled from "../../assets/icons/delete1_disabled.svg";
import clearDisabledHover from "../../assets/icons/delete1_disabled_hover.svg";
import type { IconSet } from "./IconButton";

export const PPT_ICONS: IconSet = {
  active: pptActive,
  hover: pptHover,
  disabled: pptDisabled,
  disabledHover: pptDisabledHover,
};
export const WORD_ICONS: IconSet = {
  active: wordActive,
  hover: wordHover,
  disabled: wordDisabled,
  disabledHover: wordDisabledHover,
};
export const MIC_ICONS: IconSet = {
  active: microActive,
  hover: microHover,
  disabled: microDisabled,
  disabledHover: microDisabledHover,
};
export const UPLOAD_ICONS: IconSet = {
  active: uploadActive,
  hover: uploadHover,
  disabled: uploadDisabled,
  disabledHover: uploadDisabledHover,
};
export const SEND_ICONS: IconSet = {
  active: sendActive,
  hover: sendHover,
  disabled: sendDisabled,
  disabledHover: sendDisabledHover,
};
export const STOP_ICONS: IconSet = {
  active: stopActive,
  hover: stopHover,
  disabled: stopDisabled,
  disabledHover: stopDisabledHover,
};
export const NEW_CHAT_ICONS: IconSet = {
  active: newChatActive,
  hover: newChatHover,
  disabled: newChatDisabled,
  disabledHover: newChatDisabledHover,
};
export const INFO_ICONS: IconSet = {
  active: infoActive,
  hover: infoHover,
  disabled: infoDisabled,
  disabledHover: infoDisabledHover,
};
export const HISTORY_ICONS: IconSet = {
  active: chatHistoryActive,
  hover: chatHistoryHover,
  disabled: chatHistoryDisabled,
  disabledHover: chatHistoryDisabledHover,
};
export const DELETE_ICONS: IconSet = {
  active: deleteActive,
  hover: deleteHover,
  disabled: deleteDisabled,
  disabledHover: deleteDisabledHover,
};
export const EDIT_ICONS: IconSet = {
  active: editActive,
  hover: editHover,
  disabled: editDisabled,
  disabledHover: editDisabledHover,
};
export const SEARCH_ICONS: IconSet = {
  active: searchActive,
  hover: searchHover,
  disabled: searchDisabled,
  disabledHover: searchDisabledHover,
};
export const DOWNLOAD_ICONS: IconSet = {
  active: downloadActive,
  hover: downloadHover,
  disabled: downloadDisabled,
  disabledHover: downloadDisabledHover,
};
export const CLEAR_ICONS: IconSet = {
  active: clearActive,
  hover: clearHover,
  disabled: clearDisabled,
  disabledHover: clearDisabledHover,
};
export const CLOSE_ICONS: IconSet = {
  active: closeActive,
  hover: closeHover,
  disabled: closeDisabled,
  disabledHover: closeDisabledHover,
};
export const LIBRARY_ICONS: IconSet = {
  active: libraryActive,
  hover: libraryHover,
  disabled: libraryDisabled,
  disabledHover: libraryDisabledHover,
};
